import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['container'];
  static values = {
    categoryIds: { type: Array, default: [] }
  };

  connect() {
    this.checkSeasonalCategories();
  }

  checkSeasonalCategories() {
    const checkedCategories = Array.from(
      document.querySelectorAll(
        'input[name="jobseeker[search_profile_attributes][interested_category_ids][]"]:checked'
      )
    ).map((checkbox) => parseInt(checkbox.value));

    const hasMatchingCategory = this.categoryIdsValue.some((categoryId) =>
      checkedCategories.includes(categoryId)
    );

    if (hasMatchingCategory) {
      this.containerTarget.classList.remove('hidden');
    } else {
      this.containerTarget.classList.add('hidden');
    }
  }
}
